import { combineReducers } from '@reduxjs/toolkit';
import wishlistReducer from './wishlistSlice';
import cartReducer from './cartSlice';
import customerReducer from './customerSlice';
import vendorReducer from './vendorSlice';

const userReducer = combineReducers({
  wishlist: wishlistReducer,
  cart: cartReducer,
  customer: customerReducer,
  vendor: vendorReducer
});

export default userReducer;
